import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { singleNote, createProgressNote, multipleNote } from '__mocks__/mockData/progress-notes-data';

const ProgressNotesApi = [
  rest.get(`${API_ROOT}progress-notes?patientId=200`, (req, res, ctx) => res(ctx.json(singleNote))),
  rest.get(`${API_ROOT}progress-notes`, (req, res, ctx) => {
    const patientId = req.url.searchParams.get('patientId');
    if (patientId === '200') {
      return res(ctx.json(multipleNote));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}progress-notes`, (req, res, ctx) => res(ctx.json(createProgressNote))),
];
export default ProgressNotesApi;
